import React, { useEffect, useState } from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Footer from "../footer";
import { useNavigate } from "react-router-dom";
import { viewlist } from "../../../api/BatchService";
import { StudentList } from "../../../api/StudentServices";
import { fectchIdCardV2 } from "../../../api/IdCard";
import Swal from "sweetalert2";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "./id.css";
import { imgBaseUrl } from "../../../api/api";
import { getSessions } from "../../../api/SessionsService";
import { SweetAlertShow } from "../../master/Master";
import IdCardHeader from "./IdCardHeader";

export default function IdCardV3() {
  const [idType, setIdType] = useState("student");
  const [selectedBatch, setSelectedBatch] = useState("");
  const [selectedStudent, setSelectedStudent] = useState("");
  const [selectAllStudents, setSelectAllStudents] = useState(false);
  const [showCard, setShowCard] = useState(false);
  const [batchStudents, setBatchStudents] = useState([]);
  const [batch, setBatch] = useState();
  const [renderedCards, setRenderedCards] = useState([]);
  const [idCardMeta, setIdCardMeta] = useState(null);
  const [loading, setLoading] = useState(false);
  const [idCard, setIdCard] = useState("");
  const navigate = useNavigate();
  const [sessions, setSessions] = useState([]);
  const [selectedSession, setSelectedSessions] = useState("");

  const getSession = async () => {
    setLoading(true);
    try {
      const response = await getSessions(); // <-- your API call
      if (response?.data?.status) {
        const activeSession = response?.data?.data.find(
          (session) => session.status === "1"
        );
        setSelectedSessions(activeSession.id);
        setSessions(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message
      );
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getSession();
  }, []);

  useEffect(() => {
    if (selectedSession) {
      fetchBatches();
    }
  }, [selectedSession]);

  useEffect(() => {
    if (selectedBatch) fetchStudents(selectedBatch);
  }, [selectedBatch]);

  const fetchBatches = async () => {
    const addUrl = `&session_id=${selectedSession}`;
    setLoading(true);
    try {
      const response = await viewlist(addUrl);
      if (response?.data?.status) {
        setBatch(response.data);
      } else {
        Swal.fire("Error", "Failed to fetch batches", "error");
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Error fetching batches", "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchStudents = async (batchId) => {
    setLoading(true);
    try {
      const res = await StudentList(`&batch_id=${batchId}`);
      if (res?.data?.status) setBatchStudents(res.data.data?.data || []);
      else setBatchStudents([]);
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Failed to load students", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async () => {
    try {
      let addUrl = "";

      if (idType === "student") {
        if (!selectedBatch) {
          Swal.fire("Warning", "Please select a batch", "warning");
          return;
        }
        addUrl = `&batch_id=${selectedBatch}`;

        if (!selectAllStudents) {
          if (!selectedStudent) {
            Swal.fire("Warning", "Please select a student", "warning");
            return;
          }
          addUrl += `&student_id=${selectedStudent}`;
        }

        const res = await fectchIdCardV2(addUrl);
        if (res?.data?.status) {
          const apiData = res.data?.data;
          setRenderedCards(apiData?.students || []);
          setIdCardMeta(apiData?.setting || {});
          setShowCard(true);
        } else {
          Swal.fire("Info", "No student ID cards found.", "info");
          setShowCard(false);
        }
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Failed to fetch ID cards", "error");
      setShowCard(false);
    }
  };

  const handlePrint = () => window.print();

  const getProfilePicURL = (pic) => {
    if (!pic) return "https://cdn-icons-png.flaticon.com/512/3177/3177440.png";
    // Remove trailing dot if present and add .png
    const cleanPic = pic.replace(/\.$/, "");
    return `${imgBaseUrl}${cleanPic}.png`;
  };

  const convertImgToBase64 = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous"; // important for CORS
      img.src = url;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      };
      img.onerror = (err) => reject(err);
    });
  };

  const handlePDFExport = async () => {
    const input = document.querySelector(".print-area");
    if (!input)
      return Swal.fire({ icon: "warning", title: "No ID cards to export!" });

    if (!idCard)
      return Swal.fire({
        icon: "warning",
        title: "Please select an ID card type!",
      });

    // setLoading(true);

    setTimeout(async () => {
      try {
        const cards = input.querySelectorAll(".id-cardAll"); // all cards
        if (!cards.length) {
          Swal.fire({ icon: "warning", title: "No ID cards found!" });
          setLoading(false);
          return;
        }

        const totalCards = cards.length;
        let processed = 0;

        // Create an interactive SweetAlert progress popup
        Swal.fire({
          title: "Generating PDF...",
          html: `<b>0%</b> completed`,
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        // Determine orientation from selected idCard
        const orientation = idCard.startsWith("h") ? "landscape" : "portrait";

        const pdf = new jsPDF({
          orientation: orientation,
          unit: "px",
          format: "a4",
        });

        for (let i = 0; i < totalCards; i++) {
          const card = cards[i];

          // Convert images to base64 to avoid CORS issues
          const imgs = card.querySelectorAll("img");
          for (let img of imgs) {
            try {
              const base64 = await convertImgToBase64(img.src);
              img.src = base64;
            } catch (err) {
              console.error("Failed to convert image:", img.src, err);
            }
          }

          // Capture card as canvas
          const canvas = await html2canvas(card, {
            scale: 5,
            useCORS: true,
            allowTaint: false,
          });
          const imgData = canvas.toDataURL("image/png");

          // Add page (first or subsequent)
          if (i === 0) {
            pdf.deletePage(1); // remove default
            pdf.addPage(orientation, "a4");
          } else {
            pdf.addPage(orientation, "a4");
          }

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const scale = Math.min(
            pageWidth / canvas.width,
            pageHeight / canvas.height
          );
          const imgWidth = canvas.width * scale;
          const imgHeight = canvas.height * scale;
          const x = (pageWidth - imgWidth) / 2;
          const y = (pageHeight - imgHeight) / 2;

          pdf.addImage(imgData, "PNG", x, y, imgWidth, imgHeight);

          // ✅ Update progress
          processed++;
          const percent = Math.round((processed / totalCards) * 100);
          Swal.update({
            html: `<b>${percent}%</b> completed<br>(${processed} of ${totalCards})`,
          });
        }

        pdf.save(`ID_Cards.pdf`);

        Swal.fire({
          icon: "success",
          title: "Download Complete!",
          text: `${totalCards} ID cards exported successfully.`,
        });
      } catch (err) {
        console.error(err);
        Swal.fire({ icon: "error", title: "Failed to generate PDF" });
      }
    }, 500);
  };

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999, background: "rgba(255,255,255,0.6)" }}
        >
          <div className="spinner-border text-primary" role="status" />
        </div>
      )}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid mt-2">
                <div className="row">
                  <div className="d-flex gap-2">
                    <div className="col-md-3">
                      <IdCardHeader data={"ID Card Portal"} />
                    </div>
                    <div className="col-md-9">
                      <div className="card p-4">
                        <h3 className="text-primary fw-bold mb-4">
                          Generate ID Card
                        </h3>
                        <div className="row g-3">
                          <div className=" form-floating form-floating-outline">
                            <select
                              className="form-select"
                              name="session"
                              value={selectedSession}
                              onChange={(e) =>
                                setSelectedSessions(e.target.value)
                              }
                            >
                              {/* <option value="">Select Session</option> */}
                              {sessions?.map((session) => (
                                <option
                                  key={session?.id}
                                  value={session?.id}
                                  selected={
                                    session?.status == "1" &&
                                    selectedSession?.status == "1" &&
                                    true
                                  }
                                >
                                  {session?.session}:
                                  {session?.status == "1"
                                    ? "Active"
                                    : " Inactive"}
                                  {/* Show "2023-24" */}
                                </option>
                              ))}
                            </select>

                            <label>Select Session</label>
                          </div>
                          <div className="col-md-3 form-floating form-floating-outline">
                            <select
                              className="form-select"
                              value={selectedBatch}
                              onChange={(e) => setSelectedBatch(e.target.value)}
                            >
                              <option value="">Select Batch</option>
                              {/* {batch?.batches?.map((b) => (
                          <option key={b.id} value={b.id}>{b.title}</option>
                        ))} */}
                              {batch?.batches?.map((batch, i) => {
                                const courseTitle = batch?.course?.title || "";
                                const shortCourseTitle =
                                  courseTitle.length > 20
                                    ? courseTitle.substring(0, 20) + "..."
                                    : courseTitle;

                                return (
                                  <option key={i} value={batch?.id}>
                                    {`${batch?.title} (${shortCourseTitle})`}
                                  </option>
                                );
                              })}
                            </select>
                            <label>Select Batch</label>
                          </div>

                          <div className="col-md-3 form-floating form-floating-outline">
                            <select
                              className="form-select"
                              value={selectedStudent}
                              onChange={(e) => {
                                const value = e.target.value;
                                setSelectedStudent(value);
                                setSelectAllStudents(value === "all");
                              }}
                            >
                              <option value="">Select Student</option>
                              <option value="all">All</option>
                              {batchStudents.length > 0 &&
                                batchStudents.map((student) => (
                                  <option key={student.id} value={student.id}>
                                    {student.name}
                                  </option>
                                ))}
                            </select>
                            <label>Select Student</label>
                          </div>
                          <div className="col-md-3 form-floating form-floating-outline">
                            <select
                              className="form-select"
                              value={idCard}
                              onChange={(e) => {
                                const value = e.target.value;
                                setIdCard(value);
                              }}
                            >
                              <option value="">Select IdCard</option>
                              <option value="h1">horizon_1</option>
                              <option value="h2">horizon_2</option>
                              <option value="h3">horizon_3</option>
                              <option value="h4">horizon_4</option>
                              <option value="h5">horizon_5</option>
                              <option value="v1">vertical_1</option>
                              <option value="v2">vertical_2</option>
                              <option value="v3">vertical_3</option>
                              <option value="v4">vertical_4</option>
                              <option value="v5">vertical_5</option>
                              <option value="v6">vertical_6</option>
                              <option value="v7">vertical_7</option>
                              <option value="v8">vertical_8</option>
                            </select>
                            <label>Select IdCard</label>
                          </div>

                          <div className=" text-end">
                            <button
                              className="btn btn-primary"
                              onClick={handleSearch}
                            >
                              Search
                            </button>
                          </div>
                        </div>
                      </div>

                      {idCard == "h1" && (
                        <>
                          {showCard && renderedCards.length > 0 && (
                            <>
                              <div className="text-center mt-4 no-print">
                                <button
                                  className="btn btn-success"
                                  onClick={handlePrint}
                                >
                                  Print
                                </button>
                                <button
                                  className="btn btn-info ms-2"
                                  onClick={handlePDFExport}
                                  disabled={loading}
                                >
                                  {loading ? "Generating..." : "Export PDF"}
                                </button>
                              </div>

                              <div className="print-area mt-4 d-flex flex-wrap gap-3 justify-content-center">
                                {renderedCards.map((student, index) => {
                                  const info = student.student_info;
                                  const Batch = student;
                                  return (
                                    <div className="id-card-wrapper-vertical id-cardAll">
                                      {/* <!-- Header --> */}
                                      <div className="id-card-header">
                                        <img
                                          src={`${imgBaseUrl}${idCardMeta?.logo_img}`}
                                          alt="Logo"
                                          className="id-card-logo"
                                        />
                                        <div>
                                          <h5 className="id-card-school-name">
                                            {idCardMeta?.name}
                                          </h5>
                                          {/* <small className="id-card-tagline">{idCardMeta?.tag_line}</small> */}
                                        </div>
                                      </div>

                                      {/* <!-- Photo + Details --> */}
                                      <div className="id-card-content">
                                        <div className="id-card-photo">
                                          <img
                                            src={
                                              info.profile_picture
                                                ? `${imgBaseUrl}${info.profile_picture}`
                                                : "https://cdn-icons-png.flaticon.com/512/3177/3177440.png"
                                            }
                                            alt="Student"
                                          />
                                        </div>

                                        <div className="id-card-details">
                                          <p>
                                            <b>Name:</b> {info.name}
                                          </p>
                                          <p>
                                            <b>Father:</b> {info.father_name}
                                          </p>
                                          <p>
                                            <b>Mobile:</b> {info.phone}
                                          </p>
                                          <p>
                                            <b>Batch:</b> {Batch?.batch?.title}{" "}
                                            ({Batch.session_year?.session})
                                          </p>
                                          <p>
                                            <b>Address:</b> {info.village}{" "}
                                            {info.district} {info.state}
                                          </p>
                                          {/* <p><b>District:</b> {info.district}</p>
                                    <p><b>State:</b> {info.state}</p> */}
                                          {/* <p><b>Session:</b> {student.session_year?.session}</p>
                                    <p><b>Roll No:</b> {student.roll_number}</p> */}
                                        </div>
                                      </div>

                                      {/* <!-- Footer --> */}
                                      <div className="id-card-footer">
                                        <div className="id-card-principal">
                                          <img
                                            src={`${imgBaseUrl}${idCardMeta?.signature}`}
                                            alt="Signature"
                                            className="id-card-signature"
                                          />
                                          <small>Principal</small>
                                        </div>
                                        <div className="id-card-contact">
                                          <p>
                                            <b>Address:</b>{" "}
                                            {idCardMeta?.village}{" "}
                                            {idCardMeta?.district}{" "}
                                            {idCardMeta?.state}{" "}
                                            {idCardMeta?.pin_code}
                                          </p>
                                          <p>
                                            <b>Contact:</b> {idCardMeta?.mobile}{" "}
                                            {idCardMeta?.mobile}
                                          </p>
                                        </div>
                                      </div>
                                      <p
                                        style={{
                                          fontSize: "4px",
                                          marginTop: "2px",
                                          marginLeft: "2px",
                                        }}
                                      >
                                        Generate Date:{" "}
                                        {new Date().toLocaleDateString(
                                          "en-GB",
                                          {
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                          }
                                        )}
                                      </p>
                                    </div>
                                  );
                                })}
                              </div>

                              <style>{`
     .id-cardAll {
  width: 3.37in;
  height: 2.12in;
  background: linear-gradient(135deg, #ffffff 0%, #fefefe 100%);
  border: 2px solid #f4c430; /* premium gold border */
  border-radius: 12px;
  // box-shadow: 0 5px 12px rgba(0,0,0,0.2);
  color: #222;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-family: 'Poppins', sans-serif;
  padding: 10px;
  margin: 10px auto;
  position: relative;
  overflow: hidden;
}

/* Header */
.id-card-header {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f4c430;
  padding-bottom: 4px;
  margin-bottom: 6px;
  background: linear-gradient(90deg, #e6f0ff, #ffffff);
  border-radius: 8px 8px 0 0;
  padding: 6px;
}

.id-card-logo {
  width: 36px;
  height: 36px;
  border-radius: 6px;
  margin-right: 10px;
  object-fit: contain;
  background: #f5f5f5;
  padding: 2px;
  // box-shadow: 0 1px 3px rgba(0,0,0,0.2);
}

.id-card-school-name {
  font-size: 12px;
  font-weight: 700;
  color: #f4c430; /* gold text */
  margin: 0;
  letter-spacing: 0.5px;
}

.id-card-tagline {
  font-size: 7.5px;
  color: #0077cc; /* soft blue tagline */
}

/* Content */
.id-card-content {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.id-card-photo img {
  width: 70px;
  height: 82px;
  border: 2px solid #f4c430; /* gold border */
  border-radius: 6px;
  object-fit: cover;
  background: #fefefe;
  // box-shadow: 0 2px 6px rgba(0,0,0,0.25);
}

.id-card-details {
  flex: 1;
  font-size: 8.2px;
  line-height: 1.25;
  background: #fff9e6; /* soft cream box for details */
  border-radius: 6px;
  padding: 6px 8px;
  color: #222;
  // box-shadow: inset 0 0 3px rgba(0,0,0,0.05);
}

.id-card-details p {
  margin: 1px 0;
  letter-spacing: 0.3px;
}

/* Footer */
.id-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  border-top: 1px solid #f4c430;
  padding-top: 4px;
  background: linear-gradient(90deg, #fff9e6, #ffffff);
  border-radius: 0 0 8px 8px;
  padding: 6px;
}

.id-card-signature {
  width: 50px;
  height: auto;
}

.id-card-footer small {
  font-size: 6.8px;
  color: #555;
  display: block;
  text-align: center;
}

.id-card-contact p {
  font-size: 7px;
  margin: 0;
  text-align: right;
  color: #0077cc; /* soft blue text */
}

    `}</style>
                            </>
                          )}
                        </>
                      )}

                      {idCard == "h2" && (
                        <>
                          {showCard && renderedCards.length > 0 && (
                            <>
                              <div className="text-center mt-4 no-print">
                                <button
                                  className="btn btn-success"
                                  onClick={handlePrint}
                                >
                                  Print
                                </button>
                                <button
                                  className="btn btn-info ms-2"
                                  onClick={handlePDFExport}
                                  disabled={loading}
                                >
                                  {loading ? "Generating..." : "Export PDF"}
                                </button>
                              </div>

                              <div className="print-area mt-4 d-flex flex-wrap gap-3 justify-content-center">
                                {renderedCards.map((student, index) => {
                                  const info = student.student_info;
                                  const Batch = student;
                                  return (
                                    <div className="id-card-wrapper-vertical id-cardAll">
                                      <div className="id-card-header">
                                        <img
                                          src={`${imgBaseUrl}${idCardMeta?.logo_img}`}
                                          alt="Logo"
                                          className="id-card-logo"
                                        />
                                        <div>
                                          <h5 className="id-card-school-name">
                                            {idCardMeta?.name}
                                          </h5>
                                          {/* <p><b>Session:</b> {student.session_year?.session}</p> */}
                                          {/* <small>{idCardMeta?.village},{idCardMeta?.district}</small> */}

                                          {/* <small className="id-card-tagline">{idCardMeta?.tag_line}</small> */}
                                        </div>
                                      </div>

                                      <div className="id-card-content">
                                        <div className="id-card-photo">
                                          <img
                                            src={
                                              info.profile_picture
                                                ? `${imgBaseUrl}${info.profile_picture}`
                                                : "https://cdn-icons-png.flaticon.com/512/3177/3177440.png"
                                            }
                                            alt="Student"
                                          />
                                        </div>
                                        <div className="id-card-details">
                                          <p>
                                            <b>Name:</b>
                                            {info.name}
                                          </p>
                                          <p>
                                            <b>Father:</b> {info.father_name}
                                          </p>
                                          <p>
                                            <b>Mobile:</b> {info.phone}
                                          </p>
                                          <p>
                                            <b>Batch:</b> {Batch?.batch?.title}{" "}
                                            ({Batch.session_year?.session})
                                          </p>
                                          <p>
                                            <b>Address:</b> {info.village}{" "}
                                            {info.district} {info.state}
                                          </p>
                                          {/* <p><b>Village:</b> {info.village}</p>
                                    <p><b>District:</b> {info.district}</p>
                                    <p><b>State:</b> {info.state}</p> */}
                                          {/* <p><b>Session:</b> {student.session_year?.session}</p> */}
                                          {/* <p><b>Roll No:</b> {student.roll_number}</p> */}
                                        </div>
                                      </div>

                                      <div className="id-card-footer">
                                        <div>
                                          <img
                                            src={`${imgBaseUrl}${idCardMeta?.signature}`}
                                            alt="Signature"
                                            className="id-card-signature"
                                          />
                                          <small>Principal</small>
                                        </div>
                                        <div className="id-card-contact">
                                          <p>
                                            <b>Address:</b>{" "}
                                            {idCardMeta?.village}{" "}
                                            {idCardMeta?.district}{" "}
                                            {idCardMeta?.state}{" "}
                                            {idCardMeta?.pin_code}
                                          </p>
                                          <p>
                                            <b>Contact:</b> {idCardMeta?.mobile}{" "}
                                            {idCardMeta?.mobile}
                                          </p>
                                        </div>
                                      </div>
                                      <p
                                        className="date"
                                        style={{
                                          fontSize: "4px",
                                          marginTop: "2px",
                                          marginLeft: "2px",
                                        }}
                                      >
                                        Generate Date:{" "}
                                        {new Date().toLocaleDateString(
                                          "en-GB",
                                          {
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                          }
                                        )}
                                      </p>
                                    </div>
                                  );
                                })}
                              </div>

                              <style>{`
      .id-cardAll {
  width: 3.37in; /* Real ID card width */
  height: 2.12in; /* Real ID card height */
  background: linear-gradient(145deg, #ffffff, #f5f5f5);
  border: 2px solid #004aad;
  border-radius: 10px;
  // box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  font-family: "Poppins", sans-serif;
  color: #222;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 6px 8px;
  margin: 10px auto;
}

/* Header */
.id-card-header {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ccc;
  padding-bottom: 4px;
  margin-bottom: 4px;
}

.id-card-logo {
  width: 28px;
  height: 28px;
  margin-right: 6px;
}

.id-card-school-name {
  font-size: 10px;
  font-weight: 600;
  color: #004aad;
  margin: 0;
}

.id-card-tagline {
  font-size: 7px;
  color: #555;
}

/* Photo + Details */
.id-card-content {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
}

.id-card-photo img {
  width: 60px;
  height: 70px;
  border: 1px solid #004aad;
  border-radius: 4px;
  object-fit: cover;
}

.id-card-details {
  flex: 1;
  font-size: 7.5px;
  line-height: 1.1;
}

.id-card-details p {
  margin: 0;
}

/* Footer */
.id-card-footer {
  border-top: 1px solid #ccc;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 2px;
}

.id-card-signature {
  width: 40px;
  height: auto;
}

.id-card-footer small {
  font-size: 6px;
  display: block;
  text-align: center;
  color: #333;
}

.id-card-contact p {
  font-size: 6.5px;
  margin: 0;
  text-align: right;
  color: #004aad;
}

    `}</style>
                            </>
                          )}
                        </>
                      )}
                      {idCard == "h3" && (
                        <>
                          {showCard && renderedCards.length > 0 && (
                            <>
                              <div className="text-center mt-4 no-print">
                                <button
                                  className="btn btn-success"
                                  onClick={handlePrint}
                                >
                                  Print
                                </button>
                                <button
                                  className="btn btn-info ms-2"
                                  onClick={handlePDFExport}
                                  disabled={loading}
                                >
                                  {loading ? "Generating..." : "Export PDF"}
                                </button>
                              </div>

                              <div className="print-area mt-4 d-flex flex-wrap gap-3 justify-content-center">
                                {renderedCards.map((student, index) => {
                                  const info = student.student_info;
                                  const Batch = student;

                                  return (
                                    <div className="id-card-wrapper-vertical id-cardAll">
                                      <div className="id-card-header">
                                        <img
                                          src={`${imgBaseUrl}${idCardMeta?.logo_img}`}
                                          alt="Logo"
                                          className="id-card-logo"
                                        />
                                        <div>
                                          <h5 className="id-card-school-name">
                                            {idCardMeta?.name}
                                          </h5>
                                          {/* <small className="id-card-tagline">{idCardMeta?.tag_line}</small> */}
                                        </div>
                                      </div>

                                      <div className="id-card-content">
                                        <div className="id-card-photo">
                                          <img
                                            src={
                                              info.profile_picture
                                                ? `${imgBaseUrl}${info.profile_picture}`
                                                : "https://cdn-icons-png.flaticon.com/512/3177/3177440.png"
                                            }
                                            alt="Student"
                                          />
                                        </div>

                                        <div className="id-card-details">
                                          <p>
                                            <b>Name:</b> {info.name}
                                          </p>
                                          <p>
                                            <b>Father:</b> {info.father_name}
                                          </p>
                                          <p>
                                            <b>Mobile:</b> {info.phone}
                                          </p>
                                          <p>
                                            <b>Batch:</b> {Batch?.batch?.title}{" "}
                                            ({Batch.session_year?.session})
                                          </p>
                                          <p>
                                            <b>Address:</b> {info.village}{" "}
                                            {info.district} {info.state}
                                          </p>
                                          {/* <p><b>Village:</b> {info.village}</p>
                                    <p><b>District:</b> {info.district}</p>
                                    <p><b>State:</b> {info.state}</p> */}
                                          {/* <p><b>Session:</b> {student.session_year?.session}</p>
                                    <p><b>Roll No:</b> {student.roll_number}</p> */}
                                        </div>
                                      </div>

                                      <div className="id-card-footer">
                                        <div className="id-card-principal">
                                          <img
                                            src={`${imgBaseUrl}${idCardMeta?.signature}`}
                                            alt="Signature"
                                            className="id-card-signature"
                                          />
                                          <small>Principal</small>
                                        </div>
                                        <div className="id-card-contact">
                                          <p>
                                            <b>Address:</b>{" "}
                                            {idCardMeta?.village}{" "}
                                            {idCardMeta?.district}{" "}
                                            {idCardMeta?.state}{" "}
                                            {idCardMeta?.pin_code}
                                          </p>
                                          <p>
                                            <b>Contact:</b> {idCardMeta?.mobile}{" "}
                                            {idCardMeta?.mobile}
                                          </p>
                                        </div>
                                      </div>
                                      <p
                                        style={{
                                          fontSize: "4px",
                                          marginTop: "2px",
                                          marginLeft: "2px",
                                        }}
                                      >
                                        Generate Date:{" "}
                                        {new Date().toLocaleDateString(
                                          "en-GB",
                                          {
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                          }
                                        )}
                                      </p>
                                    </div>
                                  );
                                })}
                              </div>

                              <style>{`
      .id-cardAll {
  width: 3.37in;
  height: 2.12in;
  background: linear-gradient(160deg, #004aad 0%, #0077ff 40%, #e8f1ff 100%);
  border-radius: 10px;
  // box-shadow: 0 0 6px rgba(0, 0, 0, 0.25);
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-family: 'Poppins', sans-serif;
  padding: 8px;
  margin: 10px auto;
  overflow: hidden;
  position: relative;
}

/* Subtle overlay for realism */
.id-cardAll::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 30% 30%, rgba(255,255,255,0.15), transparent 70%);
  pointer-events: none;
}

/* ===== Header ===== */
.id-card-header {
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(255,255,255,0.3);
  padding-bottom: 4px;
  margin-bottom: 4px;
}

.id-card-logo {
  width: 32px;
  height: 32px;
  background: #fff;
  border-radius: 4px;
  margin-right: 8px;
  object-fit: contain;
  padding: 2px;
}

.id-card-school-name {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  margin: 0;
  color: #fff;
  letter-spacing: 0.3px;
}

.id-card-tagline {
  font-size: 7px;
  color: #d9e8ff;
}

/* ===== Content ===== */
.id-card-content {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.id-card-photo img {
  width: 65px;
  height: 78px;
  border: 2px solid #fff;
  border-radius: 5px;
  object-fit: cover;
  background: #eee;
  // box-shadow: 0 0 3px rgba(0,0,0,0.2);
}

.id-card-details {
  flex: 1;
  font-size: 8px;
  line-height: 1.2;
  color: #fff;
  background: rgba(255,255,255,0.08);
  border-radius: 6px;
  padding: 4px 6px;
}

.id-card-details p {
  margin: 1px 0;
}

/* ===== Footer ===== */
.id-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  border-top: 1px solid rgba(255,255,255,0.3);
  padding-top: 4px;
}

.id-card-signature {
  width: 45px;
  height: auto;
  // filter: brightness(0) invert(1);
}

.id-card-footer small {
  font-size: 6px;
  color: #e0e7ff;
  display: block;
  text-align: center;
}

.id-card-contact p {
  font-size: 6.5px;
  margin: 0;
  text-align: right;
  color: #e0e7ff;
}

    `}</style>
                            </>
                          )}
                        </>
                      )}
                      {idCard == "h4" && (
                        <>
                          {showCard && renderedCards.length > 0 && (
                            <>
                              <div className="text-center mt-4 no-print">
                                <button
                                  className="btn btn-success"
                                  onClick={handlePrint}
                                >
                                  Print
                                </button>
                                <button
                                  className="btn btn-info ms-2"
                                  onClick={handlePDFExport}
                                  disabled={loading}
                                >
                                  {loading ? "Generating..." : "Export PDF"}
                                </button>
                              </div>

                              <div className="print-area mt-4 d-flex flex-wrap gap-3 justify-content-center">
                                {renderedCards.map((student, index) => {
                                  const info = student.student_info;
                                  const Batch = student;

                                  return (
                                    <div className="id-card-wrapper-vertical id-cardAll">
                                      {/* <!-- Header --> */}
                                      <div className="id-card-header">
                                        <img
                                          src={`${imgBaseUrl}${idCardMeta?.logo_img}`}
                                          alt="Logo"
                                          className="id-card-logo"
                                        />
                                        <div>
                                          <h5 className="id-card-school-name">
                                            {idCardMeta?.name}
                                          </h5>
                                          {/* <small className="id-card-tagline">{idCardMeta?.tag_line}</small> */}
                                        </div>
                                      </div>

                                      {/* <!-- Photo + Details --> */}
                                      <div className="id-card-content">
                                        <div className="id-card-photo">
                                          <img
                                            src={
                                              info.profile_picture
                                                ? `${imgBaseUrl}${info.profile_picture}`
                                                : "https://cdn-icons-png.flaticon.com/512/3177/3177440.png"
                                            }
                                            alt="Student"
                                          />
                                        </div>

                                        <div className="id-card-details">
                                          <p>
                                            <b>Name:</b> {info.name}
                                          </p>
                                          <p>
                                            <b>Father:</b> {info.father_name}
                                          </p>
                                          <p>
                                            <b>Mobile:</b> {info.phone}
                                          </p>
                                          <p>
                                            <b>Batch:</b> {Batch?.batch?.title}{" "}
                                            ({Batch.session_year?.session})
                                          </p>
                                          <p>
                                            <b>Address:</b> {info.village}{" "}
                                            {info.district} {info.state}
                                          </p>
                                          {/* <p><b>Village:</b> {info.village}</p>
                                    <p><b>District:</b> {info.district}</p>
                                    <p><b>State:</b> {info.state}</p> */}
                                          {/* <p><b>Session:</b> {student.session_year?.session}</p>
                                    <p><b>Roll No:</b> {student.roll_number}</p> */}
                                        </div>
                                      </div>

                                      {/* <!-- Footer --> */}
                                      <div className="id-card-footer">
                                        <div className="id-card-principal">
                                          <img
                                            src={`${imgBaseUrl}${idCardMeta?.signature}`}
                                            alt="Signature"
                                            className="id-card-signature"
                                          />
                                          <small>Principal</small>
                                        </div>
                                        <div className="id-card-contact">
                                          <p>
                                            <b>Address:</b>{" "}
                                            {idCardMeta?.village}{" "}
                                            {idCardMeta?.district}{" "}
                                            {idCardMeta?.state}{" "}
                                            {idCardMeta?.pin_code}
                                          </p>
                                          <p>
                                            <b>Contact:</b> {idCardMeta?.mobile}{" "}
                                            {idCardMeta?.mobile}
                                          </p>
                                        </div>
                                      </div>
                                      <p
                                        style={{
                                          fontSize: "4px",
                                          marginTop: "0px",
                                          marginLeft: "2px",
                                        }}
                                      >
                                        Generate Date:{" "}
                                        {new Date().toLocaleDateString(
                                          "en-GB",
                                          {
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                          }
                                        )}
                                      </p>
                                    </div>
                                  );
                                })}
                              </div>

                              <style>{`
     .id-cardAll {
  width: 3.37in;
  height: 2.12in;
  background: linear-gradient(135deg, #0f1b2b 0%, #1e2a44 70%, #f0f0f0 100%);
  border: 2px solid #f4c430; /* premium gold border */
  border-radius: 12px;
  // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.35);
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-family: 'Poppins', sans-serif;
  padding: 10px;
  margin: 10px auto;
  position: relative;
  overflow: hidden;
}

/* Light diagonal shine effect */
.id-cardAll::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(255,255,255,0.08) 0%, transparent 80%);
  pointer-events: none;
}

/* ===== Header ===== */
.id-card-header {
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(244,196,48,0.6); /* gold separator */
  padding-bottom: 6px;
  margin-bottom: 6px;
}

.id-card-logo {
  width: 36px;
  height: 36px;
  border-radius: 6px;
  margin-right: 10px;
  object-fit: contain;
  background: #fff;
  padding: 2px;
}

.id-card-school-name {
  font-size: 11.5px;
  font-weight: 700;
  color: #f4c430; /* gold text */
  margin: 0;
  letter-spacing: 0.5px;
}

.id-card-tagline {
  font-size: 7.5px;
  color: #e0d8a8; /* soft gold */
}

/* ===== Content ===== */
.id-card-content {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.id-card-photo img {
  width: 68px;
  height: 80px;
  border: 2px solid #f4c430;
  border-radius: 6px;
  object-fit: cover;
  // box-shadow: 0 2px 6px rgba(0,0,0,0.3);
  background: #eee;
}

.id-card-details {
  flex: 1;
  font-size: 8px;
  line-height: 1.25;
  background: rgba(255,255,255,0.05);
  border-radius: 6px;
  padding: 5px 6px;
  color: #fff;
}

.id-card-details p {
  margin: 1px 0;
  letter-spacing: 0.3px;
}

/* ===== Footer ===== */
.id-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  border-top: 1px solid rgba(244,196,48,0.5);
  padding-top: 4px;
}

.id-card-signature {
  width: 48px;
  height: auto;
  // filter: brightness(0) invert(1);
}

.id-card-footer small {
  font-size: 6.5px;
  color: #f4c430;
  display: block;
  text-align: center;
}

.id-card-contact p {
  font-size: 7px;
  margin: 0;
  text-align: right;
  color: #fffacd; /* soft cream */
}

    `}</style>
                            </>
                          )}
                        </>
                      )}
                      {idCard == "h5" && (
                        <>
                          {showCard && renderedCards.length > 0 && (
                            <>
                              <div className="text-center mt-4 no-print">
                                <button
                                  className="btn btn-success"
                                  onClick={handlePrint}
                                >
                                  Print
                                </button>
                                <button
                                  className="btn btn-info ms-2"
                                  onClick={handlePDFExport}
                                  disabled={loading}
                                >
                                  {loading ? "Generating..." : "Export PDF"}
                                </button>
                              </div>

                              <div className="print-area mt-4 d-flex flex-wrap gap-3 justify-content-center">
                                {renderedCards.map((student, index) => {
                                  const info = student.student_info;
                                  const Batch = student;

                                  return (
                                    <div className="id-card-wrapper-vertical id-cardAll">
                                      {/* <!-- Header --> */}
                                      <div className="id-card-header">
                                        <img
                                          src={`${imgBaseUrl}${idCardMeta?.logo_img}`}
                                          alt="Logo"
                                          className="id-card-logo"
                                        />
                                        <div>
                                          <h5 className="id-card-school-name">
                                            {idCardMeta?.name}
                                          </h5>
                                          {/* <small className="id-card-tagline">{idCardMeta?.tag_line}</small> */}
                                        </div>
                                      </div>

                                      {/* <!-- Photo + Details --> */}
                                      <div className="id-card-content">
                                        <div className="id-card-photo">
                                          <img
                                            src={
                                              info.profile_picture
                                                ? `${imgBaseUrl}${info.profile_picture}`
                                                : "https://cdn-icons-png.flaticon.com/512/3177/3177440.png"
                                            }
                                            alt="Student"
                                          />
                                        </div>

                                        <div className="id-card-details">
                                          <p>
                                            <b>Name:</b> {info.name}
                                          </p>
                                          <p>
                                            <b>Father:</b> {info.father_name}
                                          </p>
                                          <p>
                                            <b>Mobile:</b> {info.phone}
                                          </p>
                                          <p>
                                            <b>Batch:</b> {Batch?.batch?.title}{" "}
                                            ({Batch.session_year?.session})
                                          </p>
                                          <p>
                                            <b>Address:</b> {info.village}{" "}
                                            {info.district} {info.state}
                                          </p>
                                          {/* <p><b>Village:</b> {info.village}</p>
                                    <p><b>District:</b> {info.district}</p>
                                    <p><b>State:</b> {info.state}</p> */}
                                          {/* <p><b>Session:</b> {student.session_year?.session}</p>
                                    <p><b>Roll No:</b> {student.roll_number}</p> */}
                                        </div>
                                      </div>

                                      {/* <!-- Footer --> */}
                                      <div className="id-card-footer">
                                        <div className="id-card-principal">
                                          <img
                                            src={`${imgBaseUrl}${idCardMeta?.signature}`}
                                            alt="Signature"
                                            className="id-card-signature"
                                          />
                                          <small>Principal</small>
                                        </div>
                                        <div className="id-card-contact">
                                          <p>
                                            <b>Address:</b>{" "}
                                            {idCardMeta?.village}{" "}
                                            {idCardMeta?.district}{" "}
                                            {idCardMeta?.state}{" "}
                                            {idCardMeta?.pin_code}
                                          </p>
                                          <p>
                                            <b>Contact:</b> {idCardMeta?.mobile}{" "}
                                            {idCardMeta?.secondary_mobile}
                                          </p>
                                        </div>
                                      </div>
                                      <p
                                        style={{
                                          fontSize: "4px",
                                          marginTop: "2px",
                                          marginLeft: "2px",
                                        }}
                                      >
                                        Generate Date:{" "}
                                        {new Date().toLocaleDateString(
                                          "en-GB",
                                          {
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                          }
                                        )}
                                      </p>
                                    </div>
                                  );
                                })}
                              </div>

                              <style>{`
    .id-cardAll {
  width: 3.37in;
  height: 2.12in;
  background: #ffffff; /* print-friendly white */
  border: 2px solid #aff3ea; /* gold border */
  border-radius: 12px;
  // box-shadow: 0 4px 8px rgba(0,0,0,0.15);
  color: #222;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-family: 'Poppins', sans-serif;
  padding: 10px;
  margin: 10px auto;
  position: relative;
  overflow: hidden;
}

/* Header */
.id-card-header {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #aff3ea;
  padding-bottom: 4px;
  margin-bottom: 4px;
}

.id-card-logo {
  width: 36px;
  height: 36px;
  border-radius: 6px;
  margin-right: 10px;
  object-fit: contain;
  background: #f0f0f0;
  padding: 2px;
}

.id-card-school-name {
  font-size: 11.5px;
  font-weight: 700;
  color: #000; /* gold text */
  margin: 0;
  letter-spacing: 0.5px;
}

.id-card-tagline {
  font-size: 7.5px;
  color: #555; /* soft gray for tagline */
}

/* Content */
.id-card-content {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.id-card-photo img {
  width: 68px;
  height: 80px;
  border: 2px solid #aff3ea; /* gold border */
  border-radius: 6px;
  object-fit: cover;
  background: #f5f5f5;
}

.id-card-details {
  flex: 1;
  font-size: 8px;
  line-height: 1.25;
  background:#aff3ea45;
  // background: #fff8e1; /* soft cream box for details */
  border-radius: 6px;
  padding: 5px 6px;
  color: #222;
}

.id-card-details p {
  margin: 1px 0;
  letter-spacing: 0.3px;
}

/* Footer */
.id-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  border-top: 1px solid #aff3ea;
  padding-top: 4px;
}

.id-card-signature {
  width: 48px;
  height: auto;
}

.id-card-footer small {
  font-size: 6.5px;
  color: #555;
  display: block;
  text-align: center;
}

.id-card-contact p {
  font-size: 7px;
  margin: 0;
  text-align: right;
  color: #222;
}

    `}</style>
                            </>
                          )}
                        </>
                      )}
                      {idCard == "v0" && (
                        <>
                          {showCard && renderedCards.length > 0 && (
                            <>
                              <div className="text-center mt-4 no-print">
                                <button
                                  className="btn btn-success"
                                  onClick={handlePrint}
                                >
                                  Print
                                </button>
                                <button
                                  className="btn btn-info ms-2"
                                  onClick={handlePDFExport}
                                  disabled={loading}
                                >
                                  {loading ? "Generating..." : "Export PDF"}
                                </button>
                              </div>

                              <div className="print-area mt-4 d-flex flex-wrap gap-3 justify-content-center">
                                {renderedCards.map((student, index) => {
                                  const info = student.student_info;
                                  const Batch = student;

                                  return (
                                    <div
                                      key={index}
                                      className="id-card-wrapper-vertical id-cardAll"
                                    >
                                      {/* Header */}
                                      <div className="id-card-header">
                                        <img
                                          src={`${imgBaseUrl}${idCardMeta?.logo_img}`}
                                          alt="Logo"
                                          className="id-card-logo"
                                        />
                                        <div>
                                          <h5 className="id-card-school-name">
                                            {idCardMeta?.name}
                                          </h5>
                                          {/* <small className="id-card-tagline">{idCardMeta?.tag_line}</small> */}
                                        </div>
                                      </div>

                                      {/* Photo + Details */}
                                      <div className="id-card-content">
                                        <div className="id-card-photo">
                                          <img
                                            src={
                                              info.profile_picture
                                                ? `${imgBaseUrl}${info.profile_picture}`
                                                : "https://cdn-icons-png.flaticon.com/512/3177/3177440.png"
                                            }
                                            alt="Student"
                                          />
                                        </div>
                                        <div className="id-card-details">
                                          <p>
                                            <b>Name:</b> {info.name}
                                          </p>
                                          <p>
                                            <b>Father:</b> {info.father_name}
                                          </p>
                                          <p>
                                            <b>Mobile:</b> {info.phone}
                                          </p>
                                          <p>
                                            <b>Batch:</b> {Batch?.batch?.title}{" "}
                                            ({Batch.session_year?.session})
                                          </p>
                                          <p>
                                            <b>Address:</b> {info.village}{" "}
                                            {info.district} {info.state}
                                          </p>
                                          {/* <p><b>Village:</b> {info.village}</p>
                                    <p><b>District:</b> {info.district}</p>
                                    <p><b>State:</b> {info.state}</p>
                                    <p><b>Session:</b> {student.session_year?.session}</p>
                                    <p><b>Roll No:</b> {student.roll_number}</p> */}
                                        </div>
                                      </div>

                                      {/* Footer */}
                                      <div className="id-card-footer">
                                        <div>
                                          <img
                                            src={`${imgBaseUrl}${idCardMeta?.signature}`}
                                            alt="Signature"
                                            className="id-card-signature"
                                          />
                                          <small>Principal</small>
                                        </div>
                                        <div className="id-card-contact">
                                          <p>
                                            {idCardMeta?.village},{" "}
                                            {idCardMeta?.district}
                                          </p>
                                          <p>Contact: {idCardMeta?.mobile}</p>
                                        </div>
                                      </div>
                                      <p
                                        style={{
                                          fontSize: "4px",
                                          marginTop: "2px",
                                          marginLeft: "2px",
                                        }}
                                      >
                                        Generate Date:{" "}
                                        {new Date().toLocaleDateString(
                                          "en-GB",
                                          {
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                          }
                                        )}
                                      </p>
                                    </div>
                                  );
                                })}
                              </div>

                              <style>{`
     .id-card-wrapper-vertical {
      width: 250px;
      height: 400px; /* fixed realistic ID card height */
      border-radius: 12px;
      overflow: hidden;
      background: #fefefe;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      // box-shadow: 0 4px 10px rgba(0,0,0,0.15);
      border: 2px solid #c0c0c0;
      font-family: 'Poppins', sans-serif;
    }

    /* Header */
    .id-card-header {
      background: linear-gradient(180deg, #a8dadc, #f0f4f8);
      color: #222;
      padding: 8px 10px;
      display: flex;
      align-items: center;
      gap: 8px;
      border-bottom: 1px solid #c0c0c0;
    }
    .id-card-logo {
      width: 45px;
      height: 45px;
      border-radius: 50%;
      border: 1.5px solid #fff;
      object-fit: cover;
      background: #fff;
    }
    .id-card-school-name {
      margin: 0;
      font-size: 13px; /* reduced font size */
      font-weight: 700;
      color: #1d3557;
    }

    /* Content */
    .id-card-content {
      display: flex;
      padding: 8px 10px;
      gap: 10px;
      flex: 1;
    }
    .id-card-photo img {
      width: 75px;
      height: 95px; /* slightly smaller */
      object-fit: cover;
      border: 2px solid #457b9d;
      border-radius: 5px;
    }
    .id-card-details {
      font-size: 11px; /* slightly smaller */
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 3px; /* tighter spacing */
    }
    .id-card-details b {
      color: #1d3557;
    }

    /* Footer */
    .id-card-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 6px 10px;
      background: #fef7ef;
      border-top: 1px solid #c0c0c0;
      font-size: 9px; /* smaller font */
    }
    .id-card-signature {
      width: 55px;
      height: 22px;
      object-fit: contain;
    }
    .id-card-contact {
      text-align: right;
      color: #222;
    }
    `}</style>
                            </>
                          )}
                        </>
                      )}

                      {idCard === "v2" && renderedCards.length > 0 && (
                        <>
                          <div className="text-center mt-4 no-print mb-4">
                            <button
                              className="btn btn-success"
                              onClick={handlePrint}
                            >
                              Print
                            </button>
                            <button
                              className="btn btn-info ms-2"
                              onClick={handlePDFExport}
                              disabled={loading}
                            >
                              {loading ? "Generating..." : "Export PDF"}
                            </button>
                          </div>

                          <div className="print-area d-flex flex-wrap gap-3 justify-content-center">
                            {renderedCards.map((student, index) => {
                              const info = student.student_info;
                              const Batch = student;

                              return (
                                <div
                                  key={index}
                                  className="id-card7 id-cardAll"
                                  style={{ border: "1px solid black" }}
                                >
                                  <style>{`
            :root {
              --primary: #c62828;
              --teal: #2ca6a6;
            }
               .id-cardAll {
              width: 54mm;
              height: 85.6mm;
              border-radius: 6px;
              background: #fff;
              // box-shadow: 0 4px 14px rgba(0, 0, 0, .25);
              margin: auto;
              position: relative;
              overflow: hidden;
              display: flex;
              flex-direction: column;
            }
            // .id-card7 {
            //   width: 54mm;
            //   height: 85.6mm;
            //   border-radius: 6px;
            //   background: #fff;
            //   box-shadow: 0 4px 14px rgba(0, 0, 0, .25);
            //   margin: auto;
            //   position: relative;
            //   overflow: hidden;
            //   display: flex;
            //   flex-direction: column;
            // }
            .card-header7 { display: flex; align-items: center; gap: 3mm; padding: 2mm; border-bottom: 1px solid #000; }
            .card-header7 .logo { width: 12mm; height: 12mm; border-radius: 50%; background: #fff; overflow: hidden; border: 1px solid #ccc; flex-shrink: 0; }
            .card-header7 .logo img { width: 100%; height: 100%; object-fit: contain; }
            .school-info7 { flex: 1; }
            .school-name7 { font-weight: 700; font-size: 10px; line-height: 1.2; }
            .school-address7 { font-size: 8px; opacity: 0.9; }
            .photo-frame7 { width: 40%; margin: 2mm auto; background: var(--teal); padding: 0.8mm; border-radius: 4px; }
            .photo-frame7 img { width: 100%; height: 22mm; object-fit: cover; border-radius: 3px; }
            .details7 { padding: 2mm 5mm; flex: 1; }
            .student-name7 { background: var(--teal); color: #fff; font-weight: 700; font-size: 3mm; padding: 0.8mm; border-radius: 3px; text-align: center; margin-bottom: 5px; margin-top: -12px; }
            .card-footer7 { border-top: 1px solid #000; padding: 1.5mm 3mm; display: flex; justify-content: space-between; align-items: center; }
            .phone-pill7 { background: #fff; color: var(--primary); font-weight: 700; padding: 0.5mm 2mm; border-radius: 3mm; font-size: 6px; border: 1px solid var(--primary); }
            .signature7 { text-align: center; font-size: 2.2mm; color: #333; }
          `}</style>

                                  {/* Header */}
                                  <div className="card-header7">
                                    <div className="logo">
                                      <img
                                        src={`${imgBaseUrl}${idCardMeta?.logo_img}`}
                                        alt="School Logo"
                                      />
                                    </div>
                                    <div className="school-info7">
                                      <div className="school-name7">
                                        {idCardMeta?.name}
                                      </div>
                                      <div className="school-address7">
                                        {idCardMeta?.village}{" "}
                                        {idCardMeta?.district}{" "}
                                        {idCardMeta?.state}{" "}
                                        {idCardMeta?.pin_code}
                                      </div>
                                    </div>
                                  </div>

                                  {/* Student Photo */}
                                  <div className="photo-frame7">
                                    {/* <img
                                src={info.profile_picture ? `${imgBaseUrl}${info.profile_picture}` : "https://cdn-icons-png.flaticon.com/512/3177/3177440.png"}
                                alt="Student"
                              /> */}

                                    <img
                                      src={`${imgBaseUrl}${info.profile_picture}`}
                                      alt="Student"
                                    />
                                  </div>

                                  {/* Details */}
                                  <div className="details7">
                                    {/* Student Name */}
                                    <div
                                      className="student-name7 mb-2"
                                      style={{
                                        fontSize: "13px",
                                        fontWeight: "600",
                                      }}
                                    >
                                      {info.name}
                                    </div>

                                    {/* Roll Number */}
                                    {/* <div className="d-flex justify-content-between mb-1" style={{ fontSize: "8px" }}>
                                <div className="id-no7 fw-bold">Roll No :</div>
                                <div className="id-no7">{student.roll_number}</div>
                              </div> */}

                                    {/* Father Name */}
                                    <div
                                      className="d-flex justify-content-between mb-1"
                                      style={{ fontSize: "8px" }}
                                    >
                                      <div className="info-label7 fw-bold">
                                        Father:
                                      </div>
                                      <div className="info-value7">
                                        {info.father_name}
                                      </div>
                                    </div>

                                    {/* Mobile */}
                                    <div
                                      className="d-flex justify-content-between mb-1"
                                      style={{ fontSize: "8px" }}
                                    >
                                      <div className="info-label7 fw-bold">
                                        Mobile:
                                      </div>
                                      <div className="info-value7">
                                        {info.phone}
                                      </div>
                                    </div>
                                    <div
                                      className="d-flex justify-content-between mb-1"
                                      style={{ fontSize: "8px" }}
                                    >
                                      <div className="info-label7 fw-bold">
                                        Batch:
                                      </div>
                                      <div className="info-value7">
                                        {Batch?.batch?.title} (
                                        {Batch.session_year?.session})
                                      </div>
                                    </div>

                                    {/* Village */}
                                    <div
                                      className="d-flex justify-content-between mb-1"
                                      style={{ fontSize: "8px" }}
                                    >
                                      <div className="info-label7 fw-bold">
                                        Address:
                                      </div>
                                      <div className="info-value7">
                                        {info.village} {info.district}{" "}
                                        {info.state}
                                      </div>
                                    </div>

                                    {/* District */}
                                    {/* <div className="d-flex justify-content-between mb-1" style={{ fontSize: "8px" }}>
                                <div className="info-label7 fw-bold">District:</div>
                                <div className="info-value7">{info.district}</div>
                              </div> */}

                                    {/* State */}
                                    {/* <div className="d-flex justify-content-between mb-1" style={{ fontSize: "8px" }}>
                                <div className="info-label7 fw-bold">State:</div>
                                <div className="info-value7">{info.state}</div>
                              </div> */}
                                  </div>

                                  {/* Footer */}
                                  <div className="card-footer7">
                                    <div className="phone-pill7">
                                      {idCardMeta?.mobile}{" "}
                                      {idCardMeta?.secondary_mobile}
                                    </div>
                                    <div className="signature7">
                                      <img
                                        src={`${imgBaseUrl}${idCardMeta?.signature}`}
                                        alt="Signature"
                                        style={{
                                          height: "20px",
                                          objectFit: "contain",
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <p
                                    style={{
                                      fontSize: "2px",
                                      marginTop: "2px",
                                      marginLeft: "2px",
                                    }}
                                  >
                                    Generate Date:{" "}
                                    {new Date().toLocaleDateString("en-GB", {
                                      day: "2-digit",
                                      month: "short",
                                      year: "numeric",
                                    })}
                                  </p>
                                </div>
                              );
                            })}
                          </div>
                        </>
                      )}
                      {idCard === "v1" && renderedCards.length > 0 && (
                        <>
                          <div className="text-center mt-4 no-print mb-4">
                            <button
                              className="btn btn-success"
                              onClick={handlePrint}
                            >
                              Print
                            </button>
                            <button
                              className="btn btn-info ms-2"
                              onClick={handlePDFExport}
                              disabled={loading}
                            >
                              {loading ? "Generating..." : "Export PDF"}
                            </button>
                          </div>

                          <div className="print-area d-flex flex-wrap gap-3 justify-content-center">
                            {renderedCards.map((student, index) => {
                              const info = student.student_info;
                              const Batch = student;

                              return (
                                <div
                                  key={index}
                                  className="id-card-wrapper-vertical id-cardAll"
                                >
                                  {/* Header */}
                                  <div className="id-card-header">
                                    <img
                                      src={`${imgBaseUrl}${idCardMeta?.logo_img}`}
                                      alt="Logo"
                                      className="id-card-logo"
                                    />
                                    <div>
                                      <h5 className="id-card-school-name">
                                        {idCardMeta?.name}
                                      </h5>
                                      {/* <small className="id-card-tagline">{idCardMeta?.tag_line}</small> */}
                                    </div>
                                  </div>

                                  {/* Photo + Details */}
                                  <div className="id-card-content">
                                    <div className="id-card-photo">
                                      <img
                                        src={
                                          info?.profile_picture
                                            ? `${imgBaseUrl}${info?.profile_picture}`
                                            : "https://cdn-icons-png.flaticon.com/512/3177/3177440.png"
                                        }
                                        alt="Student"
                                      />
                                    </div>
                                    <div className="id-card-details">
                                      <p>
                                        <b>Name:</b> {info?.name}
                                      </p>
                                      <p>
                                        <b>Father:</b> {info?.father_name}
                                      </p>
                                      <p>
                                        <b>Mobile:</b> {info?.phone}
                                      </p>
                                      <p>
                                        <b>Batch:</b> {Batch?.batch?.title} (
                                        {Batch?.session_year?.session})
                                      </p>
                                      <p>
                                        <b>Address:</b> {info?.village}{" "}
                                        {info?.district} {info?.state}
                                      </p>
                                      {/* <p><b>Village:</b> {info.village}</p>
                                <p><b>District:</b> {info.district}</p>
                                <p><b>State:</b> {info.state}</p> */}
                                      {/* <p><b>Session:</b> {student.session_year?.session}</p>
      <p><b>Roll No:</b> {student.roll_number}</p> */}
                                    </div>
                                  </div>

                                  {/* Footer */}
                                  <div className="id-card-footer">
                                    <div>
                                      <img
                                        src={`${imgBaseUrl}${idCardMeta?.signature}`}
                                        alt="Signature"
                                        className="id-card-signature"
                                      />
                                      <small>Principal</small>
                                    </div>
                                    <div className="id-card-contact">
                                      <p>
                                        {" "}
                                        <b>Address :</b> {idCardMeta?.village}{" "}
                                        {idCardMeta?.district}{" "}
                                        {idCardMeta?.state}{" "}
                                        {idCardMeta?.pin_code}
                                      </p>
                                      <p>
                                        {" "}
                                        <b>Contact:</b> {idCardMeta?.mobile}{" "}
                                        {idCardMeta?.secondary_mobile}
                                      </p>
                                    </div>
                                  </div>

                                  <style>{`
    .id-card-wrapper-vertical {
      width: 250px;
      height: auto; /* fixed realistic height */
      border-radius: 12px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      // justify-content: space-between;
      // box-shadow: 0 6px 18px rgba(0,0,0,0.25);
      border: 2px solid #d4af37; /* premium gold border */
      font-family: 'Poppins', sans-serif;
      background: linear-gradient(to bottom, #fefefe 0%, #fff8e7 100%); /* soft luxury cream */
    }

    /* Header */
    .id-card-header {
      background: linear-gradient(180deg, #1d3557, #457b9d); /* deep navy to lighter navy */
      color: #fefefe;
      padding: 6px 10px;
      display: flex;
      align-items: center;
      gap: 10px;
    }
    .id-card-logo {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      border: 2px solid #f4c430; /* gold border */
      object-fit: cover;
      background: #fff;
    }
    .id-card-school-name {
      margin: 0;
      font-size: 9px;
      font-weight: 700;
      color: #f4c430; /* gold text */
    }
    .id-card-tagline {
      font-size: 9px;
      color: #ffd700; /* soft gold */
    }

    /* Content */
    .id-card-content {
      display: flex;
      padding: 8px 12px;
      gap: 12px;
      flex: 1;
    }
    .id-card-photo img {
      width: 78px;
      height: 100px;
      object-fit: cover;
      border: 2px solid #1d3557;
      border-radius: 6px;
    }
    .id-card-details {
      font-size: 8px;
      display: flex;
      flex-direction: column;
      // justify-content: space-between;
      // gap: 3px;
    }
    .id-card-details b {
      color: #1d3557;
    }

    /* Footer */
    .id-card-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 6px 10px;
      background: linear-gradient(to right, #fff8e7, #fefefe);
      border-top: 1px solid #d4af37;
      font-size: 9px;
    }
    .id-card-signature {
      width: 55px;
      height: 22px;
      object-fit: contain;
    }
    .id-card-contact {
      text-align: right;
      color: #1d3557;
    }
  `}</style>
                                  <p
                                    style={{
                                      fontSize: "4px",
                                      marginTop: "-3px",
                                      marginLeft: "2px",
                                    }}
                                  >
                                    Generate Date:{" "}
                                    {new Date().toLocaleDateString("en-GB", {
                                      day: "2-digit",
                                      month: "short",
                                      year: "numeric",
                                    })}
                                  </p>
                                </div>
                              );
                            })}
                          </div>
                        </>
                      )}

                      {idCard == "v3" && (
                        <>
                          <div className="text-center mt-4 no-print">
                            <button
                              className="btn btn-success"
                              onClick={handlePrint}
                            >
                              Print
                            </button>
                            <button
                              className="btn btn-info ms-2"
                              onClick={handlePDFExport}
                              disabled={loading}
                            >
                              {loading ? "Generating..." : "Export PDF"}
                            </button>
                          </div>

                          <div className="print-area mt-4 d-flex flex-wrap gap-3 justify-content-center ">
                            {renderedCards.map((student, index) => {
                              const info = student.student_info;
                              const Batch = student;

                              return (
                                <>
                                  <div
                                    key={index}
                                    className="id-card7 id-cardAll"
                                  >
                                    <style>{`
        .id-card8 {
          width: 210px;      /* ✅ Actual ID width */
          height: 340px;     /* ✅ Actual ID height */
          border-radius: 5px;
          // box-shadow: "0 6px 18px rgba(0,0,0,0.35)" : "0 4px 12px rgba(0,0,0,0.2)";
          overflow: hidden;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          background-color:  "#fff";
          display: flex;
          flex-direction: column;
          border:1px solid black;
          justify-content: space-between;
        }
        .header8 {
          background: linear-gradient(180deg, #d00000, #6b0000);
          color: #fff;
          text-align: center;
          padding: 3px 6px;
        }
        .header8 img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          margin-bottom: 4px;
          border: 1.5px solid #fff;
          background: #fff;
        }
        .header8 h5 {
          font-size:8px;
          font-weight: 700;
          margin: 0;
          line-height: 1.1;
        }
        .header8 p {
          font-size: 8.5px;
          margin: 1px 0;
        }
        .session8 {
          color: yellow;
          font-weight: bold;
          font-size: 9px;
          margin-top: 3px;
        }

        .photo-section8 {
          text-align: center;
          padding: 3px 0;
        }
        .photo-section8 img {
          width: 70px;
          height: 75px;
          object-fit: cover;
          border: 2px solid #222;
          border-radius: 5px;
        }

        .info-section8 {
          padding: 4px 40px;
          text-align: center;
          margin-top: -20px;
        }
        .info-section8 h6 {
          font-size: 9px;
          font-weight: bold;
          margin-bottom: 3px;
          color: #444;
        }
        .info-section8 h5 {
          font-size: 12px;
          font-weight: bold;
          margin: 4px 0;
          color: #d00000;
          text-transform: uppercase;
        }
        .info-section8 p {
          font-size: 8.5px;
          margin: 2px 0;
          line-height: 1.2;
        }

        .signature8 {
          font-size: 8px;
          font-weight: bold;
          text-align: right;
          padding: 0 10px 15px 0;
          color: #333;
        }
        .line8 {
          height: 8px;
          background: black;
          transform: skewY(355deg);
        }
      `}</style>

                                    <div className="id-card8">
                                      {/* Header */}
                                      <div className="header8">
                                        <img
                                          src={`${imgBaseUrl}${idCardMeta?.logo_img}`}
                                          alt="School Logo"
                                        />
                                        {/* <h5>{ "SENIOR SECONDARY"}</h5> */}
                                        <h5 style={{ color: "yellow" }}>
                                          {idCardMeta?.name}
                                        </h5>
                                        <p>
                                          {idCardMeta?.village}{" "}
                                          {idCardMeta?.district}{" "}
                                          {idCardMeta?.state}{" "}
                                          {idCardMeta?.pin_code}
                                        </p>
                                        <p>
                                          {idCardMeta?.mobile}{" "}
                                          {idCardMeta?.secondary_mobile}
                                        </p>
                                        {/* <p>{"Contact: 0000000000"}</p> */}
                                        {/* <p className="session8">Session: {tpl?.session || "2024-25"}</p> */}
                                      </div>

                                      {/* Photo */}
                                      <div className="photo-section8">
                                        <img
                                          src={`${imgBaseUrl}${info.profile_picture}`}
                                          alt="Student"
                                        />
                                      </div>

                                      {/* Info Section */}
                                      <div className="info-section8">
                                        {/* <h6>{tpl?.class_name ? `Class: ${tpl.class_name}` : "{class}"}</h6> */}

                                        {/* Student Name */}
                                        <div
                                          className="student-name7 mb-2"
                                          style={{
                                            fontSize: "13px",
                                            fontWeight: "600",
                                            margin: "16px",
                                          }}
                                        >
                                          {info.name}
                                        </div>

                                        {/* Roll Number */}
                                        {/* <div className="d-flex justify-content-between mb-1" style={{ fontSize: "8px" }}>
                                    <div className="id-no7 fw-bold">Roll No :</div>
                                    <div className="id-no7">{student.roll_number}</div>
                                  </div> */}

                                        {/* Father Name */}
                                        <div
                                          className="d-flex justify-content-between mb-1"
                                          style={{ fontSize: "8px" }}
                                        >
                                          <div className="info-label7 fw-bold">
                                            Father:
                                          </div>
                                          <div className="info-value7">
                                            {info.father_name}
                                          </div>
                                        </div>

                                        {/* Mobile */}
                                        <div
                                          className="d-flex justify-content-between mb-1"
                                          style={{ fontSize: "8px" }}
                                        >
                                          <div className="info-label7 fw-bold">
                                            Mobile:
                                          </div>
                                          <div className="info-value7">
                                            {info.phone}
                                          </div>
                                        </div>
                                        <div
                                          className="d-flex justify-content-between mb-1"
                                          style={{ fontSize: "8px" }}
                                        >
                                          <div className="info-label7 fw-bold">
                                            Batch:
                                          </div>
                                          <div className="info-value7">
                                            {Batch?.batch?.title} (
                                            {Batch.session_year?.session})
                                          </div>
                                        </div>

                                        {/* Village */}
                                        <div
                                          className="d-flex justify-content-between mb-1"
                                          style={{ fontSize: "8px" }}
                                        >
                                          <div className="info-label7 fw-bold">
                                            Address:
                                          </div>
                                          <div className="info-value7">
                                            {info.village} {info.district}{" "}
                                            {info.state}
                                          </div>
                                        </div>

                                        {/* District */}
                                        {/* <div className="d-flex justify-content-between mb-1" style={{ fontSize: "8px" }}>
                                    <div className="info-label7 fw-bold">District:</div>
                                    <div className="info-value7">{info.district}</div>
                                  </div> */}

                                        {/* State */}
                                        {/* <div className="d-flex justify-content-between mb-1" style={{ fontSize: "8px" }}>
                                    <div className="info-label7 fw-bold">State:</div>
                                    <div className="info-value7">{info.state}</div>
                                  </div> */}
                                      </div>

                                      {/* Footer */}
                                      <div>
                                        {/* <div  style={{ borderTop:'top', borderColor:'black',borderWidth:'2px' }}>
            <small className="number_section">9306487930 9812908671</small>
           </div> */}
                                        <div className="signature8">
                                          <img
                                            src={`${imgBaseUrl}${idCardMeta?.signature}`}
                                            alt="Signature"
                                            style={{
                                              height: "20px",
                                              objectFit: "contain",
                                            }}
                                          />
                                        </div>
                                        <p
                                          style={{
                                            fontSize: "4px",
                                            marginTop: "2px",
                                            marginLeft: "2px",
                                          }}
                                        >
                                          Generate Date:{" "}
                                          {new Date().toLocaleDateString(
                                            "en-GB",
                                            {
                                              day: "2-digit",
                                              month: "short",
                                              year: "numeric",
                                            }
                                          )}
                                        </p>
                                        <div className="line8 w-100"></div>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              );
                            })}
                          </div>
                        </>
                      )}
                      {idCard == "v4" && (
                        <>
                          <div className="text-center mt-4 no-print">
                            <button
                              className="btn btn-success"
                              onClick={handlePrint}
                            >
                              Print
                            </button>
                            <button
                              className="btn btn-info ms-2"
                              onClick={handlePDFExport}
                              disabled={loading}
                            >
                              {loading ? "Generating..." : "Export PDF"}
                            </button>
                          </div>

                          <div className="print-area mt-4 d-flex flex-wrap gap-3 justify-content-center ">
                            {renderedCards.map((student, index) => {
                              const info = student.student_info;
                              const Batch = student;

                              return (
                                <>
                                  <div
                                    key={index}
                                    className="id-card-wrapper id-cardAll"
                                  >
                                    <style>{`
    .id-cardAll {
      width: 210px;      /* Actual ID width */
      height: 340px;     /* Actual ID height */
      border-radius: 12px;
      // box-shadow: 0 6px 18px rgba(0,0,0,0.25);
      overflow: hidden;
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      background-color: #fff; /* print-friendly white */
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      border: 2px solid #f4c430; /* premium gold border */
    }

    /* Header */
    .header8 {
      background: linear-gradient(180deg, #ffd700, #f4c430);
      color: #333;
      text-align: center;
      padding: 6px 6px;
      position: relative;
    }
    .header8 img {
      width: 42px;
      height: 42px;
      border-radius: 50%;
      margin-bottom: 4px;
      border: 1.5px solid #fff;
      object-fit: cover;
      background: #fff;
      // box-shadow: 0 1px 3px rgba(0,0,0,0.2);
    }
    .header8 h5 {
      font-size: 8px;
      font-weight: 700;
      margin: 0;
      color: #222;
      line-height: 1.2;
    }
    .header8 p {
      font-size: 8px;
      margin: 2px 0 0 0;
      color: #444;
    }

    /* Photo Section */
    .photo-section8 {
      text-align: center;
      padding: 8px 0;
    }
    .photo-section8 img {
      width: 70px;
      height: 75px;
      object-fit: cover;
      border: 2px solid #f4c430;
      border-radius: 6px;
      background: #fefefe;
      // box-shadow: 0 2px 6px rgba(0,0,0,0.2);
    }

    /* Info Section */
    .info-section8 {
      padding: 3px 15px;
      background: #fff8e1; /* soft cream for better readability */
      border-radius: 6px;
      margin: 0 10px;
      // box-shadow: inset 0 0 3px rgba(0,0,0,0.05);
    }
    .info-section8 .student-name7 {
      font-size: 13px;
      font-weight: 600;
      margin-bottom: 6px;
      color: #d00000;
      text-align: center;
      text-transform: uppercase;
    }
    .info-section8 .d-flex {
      display: flex;
      justify-content: space-between;
      margin-bottom: 3px;
      font-size: 8px;
      color: #333;
    }

    /* Footer */
    .signature8 {
      text-align: right;
      padding: 6px 12px 4px 0;
    }
    .signature8 img {
      height: 22px;
      object-fit: contain;
    }
    .line8 {
      height: 2px;
      background: #f4c430;
      margin-top: 4px;
      border-radius: 1px;
    }
  `}</style>

                                    <div className="id-card8">
                                      {/* Header */}
                                      <div className="header8">
                                        <img
                                          src={`${imgBaseUrl}${idCardMeta?.logo_img}`}
                                          alt="School Logo"
                                        />
                                        <h5>{idCardMeta?.name}</h5>
                                        <p>
                                          {idCardMeta?.village}{" "}
                                          {idCardMeta?.district}{" "}
                                          {idCardMeta?.state}{" "}
                                          {idCardMeta?.pin_code}
                                        </p>
                                        <p>
                                          {idCardMeta?.mobile}{" "}
                                          {idCardMeta?.secondary_mobile}
                                        </p>
                                      </div>

                                      {/* Photo */}
                                      <div className="photo-section8">
                                        <img
                                          src={`${imgBaseUrl}${info.profile_picture}`}
                                          alt="Student"
                                        />
                                      </div>

                                      {/* Info Section */}
                                      <div className="info-section8">
                                        <div className="student-name7">
                                          {info.name}
                                        </div>

                                        {/* <div className="d-flex">
                                    <div className="fw-bold">Roll No:</div>
                                    <div>{student.roll_number}</div>
                                  </div> */}

                                        <div className="d-flex">
                                          <div className="fw-bold">Father:</div>
                                          <div>{info.father_name}</div>
                                        </div>

                                        <div className="d-flex">
                                          <div className="fw-bold">Mobile:</div>
                                          <div>{info.phone}</div>
                                        </div>
                                        <div className="d-flex">
                                          <div className="fw-bold">Batch:</div>
                                          <div>
                                            {Batch?.batch?.title} (
                                            {Batch.session_year?.session})
                                          </div>
                                        </div>

                                        <div className="d-flex">
                                          <div className="fw-bold">
                                            Address:
                                          </div>
                                          <div>
                                            {info.village} {info.district}{" "}
                                            {info.state}
                                          </div>
                                        </div>

                                        {/* <div className="d-flex">
                                    <div className="fw-bold">District:</div>
                                    <div>{info.district}</div>
                                  </div>

                                  <div className="d-flex">
                                    <div className="fw-bold">State:</div>
                                    <div>{info.state}</div>
                                  </div> */}
                                      </div>

                                      {/* Footer */}
                                      <div>
                                        <div className="signature8">
                                          <img
                                            src={`${imgBaseUrl}${idCardMeta?.signature}`}
                                            alt="Signature"
                                          />
                                        </div>
                                        <div className="line8 w-100"></div>
                                      </div>
                                      <div className="manoj">
                                        <p
                                          style={{
                                            fontSize: "4px",
                                            marginTop: "10px",
                                            marginLeft: "2px",
                                          }}
                                        >
                                          Generate Date:{" "}
                                          {new Date().toLocaleDateString(
                                            "en-GB",
                                            {
                                              day: "2-digit",
                                              month: "short",
                                              year: "numeric",
                                            }
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              );
                            })}
                          </div>
                        </>
                      )}
                      {idCard == "v5" && (
                        <>
                          <div className="text-center mt-4 no-print">
                            <button
                              className="btn btn-success"
                              onClick={handlePrint}
                            >
                              Print
                            </button>
                            <button
                              className="btn btn-info ms-2"
                              onClick={handlePDFExport}
                              disabled={loading}
                            >
                              {loading ? "Generating..." : "Export PDF"}
                            </button>
                          </div>

                          <div className="print-area mt-4 d-flex flex-wrap gap-3 justify-content-center ">
                            {renderedCards.map((student, index) => {
                              const info = student.student_info;
                              const Batch = student;

                              return (
                                <>
                                  <div
                                    key={index}
                                    className="id-card-wrapper id-cardAll"
                                  >
                                    <style>{`
    .id-cardAll {
      width: 210px;
      height: 340px;
      border-radius: 12px;
      // box-shadow: 0 6px 18px rgba(0,0,0,0.2);
      overflow: hidden;
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      background-color: #fefefe; /* print-friendly white */
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      border: 2px solid #c0c0c0; /* subtle silver border */
    }

    /* Header */
    .header8 {
      background: linear-gradient(180deg, #a8dadc, #f0f4f8); /* soft pastel blue */
      color: #222;
      text-align: center;
      padding: 3px 6px;
      position: relative;
      border-bottom: 1px solid #c0c0c0;
    }
    .header8 img {
      width: 42px;
      height: 42px;
      border-radius: 50%;
      margin-bottom: 4px;
      border: 1px solid #c0c0c0;
      object-fit: cover;
      background: #fff;
    }
    .header8 h5 {
      font-size: 8px;
      font-weight: 700;
      margin: 0;
      color: #1d3557; /* navy-blue text */
      line-height: 1.2;
    }
    .header8 p {
      font-size: 8px;
      margin: 2px 0 0 0;
      color: #457b9d; /* soft muted blue */
    }

    /* Photo Section */
    .photo-section8 {
      text-align: center;
      padding: 7px 0;
    }
    .photo-section8 img {
      width: 70px;
      height: 75px;
      object-fit: cover;
      border: 2px solid #457b9d; /* subtle blue border */
      border-radius: 6px;
      background: #fefefe;
      // box-shadow: 0 2px 6px rgba(0,0,0,0.15);
    }

    /* Info Section */
    .info-section8 {
      padding: 6px 15px;
      background: #fef7ef; /* soft cream */
      border-radius: 6px;
      margin: 0 10px;
      // box-shadow: inset 0 0 2px rgba(0,0,0,0.05);
    }
    .info-section8 .student-name7 {
      font-size: 13px;
      font-weight: 600;
      margin-bottom: 6px;
      color: #e63946; /* subtle red */
      text-align: center;
      text-transform: uppercase;
    }
    .info-section8 .d-flex {
      display: flex;
      justify-content: space-between;
      margin-bottom: 3px;
      font-size: 8px;
      color: #222;
    }

    /* Footer */
    .signature8 {
      text-align: right;
      padding: 6px 12px 4px 0;
    }
    .signature8 img {
      height: 22px;
      object-fit: contain;
    }
    .line8 {
      height: 2px;
      background: #c0c0c0; /* subtle silver line */
      margin-top: 4px;
      border-radius: 1px;
    }
  `}</style>

                                    <div className="id-card8">
                                      {/* Header */}
                                      <div className="header8">
                                        <img
                                          src={`${imgBaseUrl}${idCardMeta?.logo_img}`}
                                          alt="School Logo"
                                        />
                                        <h5>{idCardMeta?.name}</h5>
                                        <p>
                                          {idCardMeta?.village}{" "}
                                          {idCardMeta?.district}{" "}
                                          {idCardMeta?.state}{" "}
                                          {idCardMeta?.pin_code}
                                        </p>
                                        <p>
                                          {idCardMeta?.mobile}{" "}
                                          {idCardMeta?.secondary_mobile}
                                        </p>
                                      </div>

                                      {/* Photo */}
                                      <div className="photo-section8">
                                        <img
                                          src={`${imgBaseUrl}${info.profile_picture}`}
                                          alt="Student"
                                        />
                                      </div>

                                      {/* Info Section */}
                                      <div className="info-section8">
                                        <div className="student-name7">
                                          {info.name}
                                        </div>

                                        {/* <div className="d-flex">
                                    <div className="fw-bold">Roll No:</div>
                                    <div>{student.roll_number}</div>
                                  </div> */}

                                        <div className="d-flex">
                                          <div className="fw-bold">Father:</div>
                                          <div>{info.father_name}</div>
                                        </div>

                                        <div className="d-flex">
                                          <div className="fw-bold">Mobile:</div>
                                          <div>{info.phone}</div>
                                        </div>
                                        <div className="d-flex">
                                          <div className="fw-bold">Batch:</div>
                                          <div>
                                            {Batch?.batch?.title} (
                                            {Batch.session_year?.session})
                                          </div>
                                        </div>

                                        <div className="d-flex">
                                          <div className="fw-bold">
                                            Address:
                                          </div>
                                          <div>
                                            {info.village} {info.district}{" "}
                                            {info.state}
                                          </div>
                                        </div>

                                        {/* <div className="d-flex">
                                    <div className="fw-bold">District:</div>
                                    <div>{info.district}</div>
                                  </div>

                                  <div className="d-flex">
                                    <div className="fw-bold">State:</div>
                                    <div>{info.state}</div>
                                  </div> */}
                                      </div>

                                      {/* Footer */}
                                      <div>
                                        <div className="signature8">
                                          <img
                                            src={`${imgBaseUrl}${idCardMeta?.signature}`}
                                            alt="Signature"
                                          />
                                        </div>
                                        <div className="line8 w-100"></div>
                                      </div>
                                      <p
                                        style={{
                                          fontSize: "4px",
                                          marginTop: "10px",
                                          marginLeft: "2px",
                                        }}
                                      >
                                        Generate Date:{" "}
                                        {new Date().toLocaleDateString(
                                          "en-GB",
                                          {
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                          }
                                        )}
                                      </p>
                                    </div>
                                  </div>
                                </>
                              );
                            })}
                          </div>
                        </>
                      )}
                      {idCard == "v6" && (
                        <>
                          <div className="text-center mt-4 no-print">
                            <button
                              className="btn btn-success"
                              onClick={handlePrint}
                            >
                              Print
                            </button>
                            <button
                              className="btn btn-info ms-2"
                              onClick={handlePDFExport}
                              disabled={loading}
                            >
                              {loading ? "Generating..." : "Export PDF"}
                            </button>
                          </div>

                          <div className="print-area mt-4 d-flex flex-wrap gap-3 justify-content-center ">
                            {renderedCards.map((student, index) => {
                              const info = student.student_info;
                              const Batch = student;

                              return (
                                <>
                                  <div
                                    key={index}
                                    className="id-card-wrapper-modern"
                                  >
                                    {/* Header */}
                                    <div className="id-card-header-modern">
                                      <img
                                        src={`${imgBaseUrl}${idCardMeta?.logo_img}`}
                                        alt="School Logo"
                                        className="id-card-logo-modern"
                                      />
                                      <div>
                                        <h5 className="id-card-school-name-modern">
                                          {idCardMeta?.name}
                                        </h5>
                                        {/* {idCardMeta?.tag_line && <small className="id-card-tagline-modern">{idCardMeta?.tag_line}</small>} */}
                                      </div>
                                    </div>

                                    {/* Photo + Info */}
                                    <div className="id-card-body-modern">
                                      <div className="id-card-photo-modern">
                                        <img
                                          src={
                                            info.profile_picture
                                              ? `${imgBaseUrl}${info.profile_picture}`
                                              : "https://cdn-icons-png.flaticon.com/512/3177/3177440.png"
                                          }
                                          alt="Student"
                                        />
                                      </div>
                                      <div className="id-card-details-modern">
                                        <p>
                                          <b>Name:</b> {info.name}
                                        </p>
                                        <p>
                                          <b>Father:</b> {info.father_name}
                                        </p>
                                        <p>
                                          <b>Mobile:</b> {info.phone}
                                        </p>
                                        <p>
                                          <b>Batch:</b>
                                          {Batch?.batch?.title} (
                                          {Batch.session_year?.session})
                                        </p>
                                        <p>
                                          <b>Address:</b> {info.village}{" "}
                                          {info.district} {info.state}
                                        </p>
                                      </div>
                                    </div>

                                    {/* Footer */}
                                    <div className="id-card-footer-modern">
                                      <div className="id-card-signature-section-modern">
                                        <img
                                          src={`${imgBaseUrl}${idCardMeta?.signature}`}
                                          alt="Signature"
                                          className="id-card-signature-modern"
                                        />
                                        <small>Principal</small>
                                      </div>
                                      <div className="id-card-contact-modern">
                                        <p>
                                          {" "}
                                          <b>Address :</b> {idCardMeta?.village}{" "}
                                          {idCardMeta?.district}{" "}
                                          {idCardMeta?.state}{" "}
                                          {idCardMeta?.pin_code}
                                        </p>
                                        <p>
                                          <b>Contact:</b> {idCardMeta?.mobile}{" "}
                                          {idCardMeta?.secondary_mobile}
                                        </p>
                                      </div>
                                    </div>

                                    <style>{`
    .id-card-wrapper-modern {
      width: 250px;
      height: 400px;
      border-radius: 16px;
      overflow: hidden;
      background: linear-gradient(180deg, #fdf6f0, #fffdfc); /* soft cream gradient */
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      // box-shadow: 0 12px 28px rgba(0,0,0,0.25);
      border: 2px solid #e6b89c; /* rose-gold subtle */
      font-family: 'Poppins', sans-serif;
      transition: transform 0.3s;
    }
    .id-card-wrapper-modern:hover {
      transform: translateY(-3px) scale(1.02);
      // box-shadow: 0 15px 35px rgba(0,0,0,0.35);
    }

    /* Header */
    .id-card-header-modern {
      background: linear-gradient(135deg, #2c3e50, #4ca1af); /* deep teal gradient */
      color: #fff;
      padding: 12px;
      display: flex;
      align-items: center;
      gap: 12px;
      border-bottom: 2px solid #e6b89c;
    }
    .id-card-logo-modern {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      border: 2px solid #e6b89c; /* rose-gold border */
      object-fit: cover;
      background: #fff;
      // box-shadow: 0 2px 8px rgba(0,0,0,0.2);
    }
    .id-card-school-name-modern {
      margin: 0;
      font-size: 8px;
      font-weight: 700;
      color: #f4c087; /* goldish */
    }
    .id-card-tagline-modern {
      font-size: 10px;
      color: #fcd3a2;
    }

    /* Body */
    .id-card-body-modern {
      display: flex;
      gap: 14px;
      padding: 12px;
      flex: 1;
    }
    .id-card-photo-modern img {
      width: 82px;
      height: 104px;
      object-fit: cover;
      border-radius: 8px;
      border: 2px solid #2c3e50;
      // box-shadow: 0 3px 8px rgba(0,0,0,0.2);
    }
    .id-card-details-modern {
      display: flex;
      flex-direction: column;
      // justify-content: space-between;
      // gap: 4px;
      font-size: 8px;
    }
    .id-card-details-modern b {
      color: #2c3e50; /* deep teal labels */
    }

    /* Footer */
    .id-card-footer-modern {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px 12px;
      background: linear-gradient(to right, #fdf6f0, #fffdfc);
      border-top: 2px solid #e6b89c;
      font-size: 10px;
    }
    .id-card-signature-section-modern {
      text-align: right;
    }
    .id-card-signature-modern {
      width: 62px;
      height: 24px;
      object-fit: contain;
    }
    .id-card-contact-modern {
      text-align: right;
      color: #2c3e50;
    }
  `}</style>
                                  </div>
                                </>
                              );
                            })}
                          </div>
                        </>
                      )}

                      {idCard == "v7" && (
                        <>
                          <div className="text-center mt-4 no-print">
                            <button
                              className="btn btn-success"
                              onClick={handlePrint}
                            >
                              Print
                            </button>
                            <button
                              className="btn btn-info ms-2"
                              onClick={handlePDFExport}
                              disabled={loading}
                            >
                              {loading ? "Generating..." : "Export PDF"}
                            </button>
                          </div>

                          <div className="print-area mt-4 d-flex flex-wrap gap-3 justify-content-center ">
                            {renderedCards.map((student, index) => {
                              const info = student.student_info;
                              const Batch = student;

                              return (
                                <>
                                  <div
                                    key={index}
                                    className="id-card-wrapper-modern"
                                  >
                                    <style>{`
    .id-card-wrapper-modern {
      width: 220px;
      height: 350px;
      border-radius: 16px;
      overflow: hidden;
      font-family: 'Poppins', sans-serif;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      background: #ffffff;
      // box-shadow: 0 10px 25px rgba(0,0,0,0.15);
      border: 1px solid #e0e0e0;
      transition: transform 0.3s, box-shadow 0.3s;
    }

    .id-card-wrapper-modern:hover {
      transform: translateY(-5px);
      // box-shadow: 0 15px 30px rgba(0,0,0,0.2);
    }

    /* Header */
    .header-modern {
      background: linear-gradient(180deg, #4facfe, #00f2fe);
      color: #fff;
      text-align: center;
      padding: 3px 6px;
      position: relative;
    }
    .header-modern img {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      border: 2px solid #fff;
      object-fit: cover;
      margin-bottom: 6px;
      background: #fff;
    }
    .header-modern h5 {
      font-size: 8px;
      font-weight: 700;
      margin: 0;
      line-height: 1.2;
    }
    .header-modern p {
      font-size: 10px;
      margin: 2px 0 0 0;
      opacity: 0.9;
    }

    /* Photo Section */
    .photo-section-modern {
      text-align: center;
      padding: 3px 0;
      background: #f0f8ff;
    }
    .photo-section-modern img {
      width: 75px;
      height: 75px;
      object-fit: cover;
      border-radius: 8px;
      border: 2px solid #4facfe;
      // box-shadow: 0 4px 10px rgba(0,0,0,0.1);
    }

    /* Info Section */
    .info-section-modern {
      padding: 3px 16px;
      background: #fdfdfd;
      margin: 0 12px;
      border-radius: 10px;
      // box-shadow: inset 0 0 5px rgba(0,0,0,0.03);
    }
    .info-section-modern .student-name-modern {
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 8px;
      color: #ff6b6b;
      text-align: center;
      text-transform: uppercase;
    }
    .info-section-modern .d-flex {
      display: flex;
      justify-content: space-between;
      margin-bottom: 2px;
      font-size: 9px;
      color: #333;
    }
    .info-section-modern .d-flex .fw-bold {
      font-weight: 600;
      color: #1a1a1a;
    }

    /* Footer */
    .signature-modern {
      text-align: right;
      padding: 8px 12px 4px 0;
    }
    .signature-modern img {
      height: 24px;
      object-fit: contain;
    }
    .line-modern {
      height: 2px;
      background: linear-gradient(90deg, #4facfe, #00f2fe);
      margin-top: 6px;
      border-radius: 2px;
    }
  `}</style>

                                    <div className="id-card-modern">
                                      {/* Header */}
                                      <div className="header-modern">
                                        <img
                                          src={`${imgBaseUrl}${idCardMeta?.logo_img}`}
                                          alt="School Logo"
                                        />
                                        <h5>{idCardMeta?.name}</h5>
                                        <p>
                                          {idCardMeta?.village}{" "}
                                          {idCardMeta?.district}{" "}
                                          {idCardMeta?.state}{" "}
                                          {idCardMeta?.pin_code}
                                        </p>
                                        <p>
                                          {idCardMeta?.mobile}{" "}
                                          {idCardMeta?.secondary_mobile}
                                        </p>
                                      </div>

                                      {/* Photo */}
                                      <div className="photo-section-modern">
                                        <img
                                          src={`${imgBaseUrl}${info.profile_picture}`}
                                          alt="Student"
                                        />
                                      </div>

                                      {/* Info Section */}
                                      <div className="info-section-modern">
                                        <div className="student-name-modern">
                                          {info.name}
                                        </div>

                                        {/* <div className="d-flex">
                                    <div className="fw-bold">Roll No:</div>
                                    <div>{student.roll_number}</div>
                                  </div> */}

                                        <div className="d-flex">
                                          <div className="fw-bold">Father:</div>
                                          <div>{info.father_name}</div>
                                        </div>

                                        <div className="d-flex">
                                          <div className="fw-bold">Mobile:</div>
                                          <div>{info.phone}</div>
                                        </div>

                                        <div className="d-flex">
                                          <div className="fw-bold">Batch:</div>
                                          <div>
                                            {Batch?.batch?.title} (
                                            {Batch.session_year?.session})
                                          </div>
                                        </div>

                                        <div className="d-flex">
                                          <div className="fw-bold">
                                            Village:
                                          </div>
                                          <div>
                                            {info.village} {info.district}{" "}
                                            {info.state}
                                          </div>
                                        </div>

                                        {/* <div className="d-flex">
                                    <div className="fw-bold">State:</div>
                                    <div>{info.state}</div>
                                  </div> */}
                                      </div>

                                      {/* Footer */}
                                      <div>
                                        <div className="signature-modern">
                                          <img
                                            src={`${imgBaseUrl}${idCardMeta?.signature}`}
                                            alt="Signature"
                                          />
                                        </div>
                                        <div className="line-modern w-100"></div>
                                      </div>
                                      <p
                                        style={{
                                          fontSize: "4px",
                                          marginTop: "4px",
                                          marginLeft: "4px",
                                        }}
                                      >
                                        Generate Date:{" "}
                                        {new Date().toLocaleDateString(
                                          "en-GB",
                                          {
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                          }
                                        )}
                                      </p>
                                    </div>
                                  </div>
                                </>
                              );
                            })}
                          </div>
                        </>
                      )}
                      {idCard == "v8" && (
                        <>
                          <div className="text-center mt-4 no-print">
                            <button
                              className="btn btn-success"
                              onClick={handlePrint}
                            >
                              Print
                            </button>
                            <button
                              className="btn btn-info ms-2"
                              onClick={handlePDFExport}
                              disabled={loading}
                            >
                              {loading ? "Generating..." : "Export PDF"}
                            </button>
                          </div>

                          <div className="print-area mt-4 d-flex flex-wrap gap-3 justify-content-center ">
                            {renderedCards.map((student, index) => {
                              const info = student.student_info;
                              const Batch = student;

                              return (
                                <>
                                  <div
                                    key={index}
                                    className="id-card-wrapper-dark"
                                  >
                                    <style>{`
    /* Wrapper */
    .id-card-wrapper-dark {
      width: 220px;
      height: 350px;
      border-radius: 16px;
      overflow: hidden;
      font-family: 'Poppins', sans-serif;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      background: #1e1e2f; /* dark base */
      border: 1px solid #3a3a50;
      // box-shadow: 0 10px 25px rgba(0,0,0,0.4);
      transition: transform 0.3s, box-shadow 0.3s;
      color: #e0e0e0;
    }
    .id-card-wrapper-dark:hover {
      transform: translateY(-5px);
      // box-shadow: 0 15px 30px rgba(0,0,0,0.6);
    }

    /* Header */
    .header-dark {
      background: linear-gradient(180deg, #6a11cb, #2575fc);
      text-align: center;
      padding: 8px 6px;
      color: #ffffff;
    }
    .header-dark img {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      border: 2px solid #ffffff;
      object-fit: cover;
      margin-bottom: 6px;
      background: #fff;
    }
    .header-dark h5 {
      font-size: 12px;
      font-weight: 700;
      margin: 0;
      line-height: 1.2;
    }
    .header-dark p {
      font-size: 10px;
      margin: 2px 0 0 0;
      opacity: 0.9;
    }

    /* Photo Section */
    .photo-section-dark {
      text-align: center;
      padding: 0px 0;
      background: #2a2a3d;
    }
    .photo-section-dark img {
      width: 75px;
      height: 80px;
      border-radius: 8px;
      border: 2px solid #6a11cb;
      object-fit: cover;
      // box-shadow: 0 4px 12px rgba(0,0,0,0.3);
    }

    /* Info Section */
    .info-section-dark {
      padding: 0px 16px;
      background: #252535;
      margin: 0 12px;
      border-radius: 10px;
      // box-shadow: inset 0 0 10px rgba(255,255,255,0.05);
    }
    .info-section-dark .student-name-dark {
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 10px;
      text-align: center;
      text-transform: uppercase;
      color: #ff6b81; /* pink highlight */
    }
    .info-section-dark .d-flex {
      display: flex;
      justify-content: space-between;
      margin-bottom: 4px;
      font-size: 8px;
      color: #e0e0e0;
    }
    .info-section-dark .d-flex .fw-bold {
      font-weight: 600;
      color: #ffffff;
    }

    /* Footer */
    .signature-dark {
      text-align: right;
      padding: 8px 12px 6px 0;
    }
    .signature-dark img {
      height: 24px;
      object-fit: contain;
      // filter: brightness(0) invert(1);
    }
    .line-dark {
      height: 2px;
      background: linear-gradient(90deg, #6a11cb, #2575fc);
      margin-top: 6px;
      border-radius: 2px;
    }
  `}</style>

                                    <div className="id-card-dark">
                                      {/* Header */}
                                      <div className="header-dark">
                                        <img
                                          src={`${imgBaseUrl}${idCardMeta?.logo_img}`}
                                          alt="School Logo"
                                        />
                                        <h5>{idCardMeta?.name}</h5>
                                        <p>
                                          {idCardMeta?.village}{" "}
                                          {idCardMeta?.district}{" "}
                                          {idCardMeta?.state}{" "}
                                          {idCardMeta?.pin_code}
                                        </p>
                                        <p>
                                          {idCardMeta?.mobile}{" "}
                                          {idCardMeta?.secondary_mobile}
                                        </p>
                                      </div>

                                      {/* Photo */}
                                      <div className="photo-section-dark">
                                        <img
                                          src={`${imgBaseUrl}${info?.profile_picture}`}
                                          alt="Student"
                                        />
                                      </div>

                                      {/* Info Section */}
                                      <div className="info-section-dark">
                                        <div className="student-name-dark">
                                          {info?.name}
                                        </div>

                                        {/* <div className="d-flex">
                                    <div className="fw-bold">Roll No:</div>
                                    <div>{student.roll_number}</div>
                                  </div> */}

                                        <div className="d-flex">
                                          <div className="fw-bold">Father:</div>
                                          <div>{info?.father_name}</div>
                                        </div>

                                        <div className="d-flex">
                                          <div className="fw-bold">Mobile:</div>
                                          <div>{info?.phone}</div>
                                        </div>

                                        <div className="d-flex">
                                          <div className="fw-bold">Batch:</div>
                                          <div>
                                            {" "}
                                            {Batch?.batch?.title} (
                                            {Batch?.session_year?.session})
                                          </div>
                                        </div>

                                        <div className="d-flex">
                                          <div className="fw-bold">
                                            Village:
                                          </div>
                                          <div>
                                            {info?.village} {info?.district}{" "}
                                            {info?.state}
                                          </div>
                                        </div>
                                      </div>

                                      {/* Footer */}
                                      <div>
                                        <div className="signature-dark d-flex justify-content-between">
                                          <p
                                            style={{
                                              fontSize: "4px",
                                              marginTop: "8px",
                                              marginLeft: "12px",
                                            }}
                                          >
                                            Generate Date:{" "}
                                            {new Date().toLocaleDateString(
                                              "en-GB",
                                              {
                                                day: "2-digit",
                                                month: "short",
                                                year: "numeric",
                                              }
                                            )}
                                          </p>
                                          <img
                                            src={`${imgBaseUrl}${idCardMeta?.signature}`}
                                            alt="Signature"
                                          />
                                        </div>
                                        <div className="line-dark w-100"></div>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              );
                            })}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
